// Coquille persistante de toutes les pages, en trois variantes selon
// `shell.layout` : application, blog et devise (authentification).
// Rendue une fois ; seule la page (children) change d'une navigation à
// l'autre, ce qui garde ouverts le chatbot, les sous-menus, etc.
//
// Ce qui s'affiche dépend des props serveur `shell` (ReactShell#react_shell) :
// chaque morceau absent (null) n'est pas rendu.
import type { ReactNode } from 'react'
import { useShared } from '@/hooks/useShared'
import Sidebar from '@/components/shell/Sidebar'
import Navigation from '@/components/shell/Navigation'
import PromoBanner from '@/components/shell/PromoBanner'
import Flash from '@/components/shell/Flash'
import Footer from '@/components/shell/Footer'
import LanguageDropdown from '@/components/shell/LanguageDropdown'
import BottomNav from '@/components/shell/BottomNav'
import Chatbot from '@/components/shell/Chatbot'
import Welcome from '@/components/shell/Welcome'
import PageEffects from '@/components/shell/PageEffects'
import { AfterMainOutlet } from '@/layouts/AfterMain'

export default function AppShell({ children }: { children: ReactNode }) {
  const { shell } = useShared()
  const main =
    shell.layout === 'devise' ? (
      <div className="devise-container">
        <div className="devise-background">
          <div className="devise-grid"></div>
          <div className="devise-glow"></div>
          <div className="devise-orbs">
            <div className="orb orb-1"></div>
            <div className="orb orb-2"></div>
            <div className="orb orb-3"></div>
          </div>
        </div>

        <div className="devise-content">
          <div className="devise-card">
            <div className="devise-body-content">{children}</div>
          </div>
        </div>
      </div>
    ) : (
      children
    )

  return (
    <>
      {shell.sidebar && <Sidebar data={shell.sidebar} />}
      {shell.navigation && <Navigation data={shell.navigation} />}
      {shell.promoBanner && <PromoBanner data={shell.promoBanner} />}
      {shell.flash && <Flash data={shell.flash} />}
      <div id="main-content" className="flex-grow-1">
        {main}
      </div>
      <AfterMainOutlet />
      {shell.footer && <Footer data={shell.footer} />}
      {shell.languageDropdown && <LanguageDropdown data={shell.languageDropdown} />}
      {shell.bottomNav && <BottomNav data={shell.bottomNav} />}
      {shell.chatbot && <Chatbot data={shell.chatbot} />}
      {shell.welcome && <Welcome data={shell.welcome} />}
      <PageEffects />
      {shell.layout === 'devise' && (
        <style>{`
      /* Devise Layout Specific Styles */
      .devise-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2rem;
      }
      `}</style>
      )}
    </>
  )
}
